import { api } from "../api";

export const sendCode = async (email) => {
  try {
    const response = await api.post("/auth/send_code", {
      email: email
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const confirmCode = async (userId, code) => {
  try {
    const response = await api.post("/auth/confirm", {
      user_id: userId,
      code: code
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
